export default {
  name: 'EditBillingIncomingInvoiceItems',
  props: {
    items: {
      required: true,
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      required: true,
      type: Boolean,
      default: true
    }
  }
}
